<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div class="flex items-center justify-between w-full">
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>

            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
              <div class="p-4">
                <p> 
                  Motivos para rechazar pedidos o entregas.
                  Ej.: cliente ausente, precio incorrecto,
                  dirección equivocada, producto dañado.
                  Úsalo para clasificar por qué se rechazó
                  y tomar acciones (reprogramar, ajustar
                  precio, reponer stock).
                </p>
              </div>
            </mat-menu>

            <h2 class="text-xl font-semibold leading-8 tracking-tight">
              De Rechazo
            </h2>
          </div>
          <div class="text-sm text-secondary font-medium tracking-tight">
            Visualiza los tipos de <b>documentos</b> disponibles para ejecutar un <b>rechazo</b> dentro de AVE.
          </div>
        </div>
        <app-status-filters
        [selectedStatuses]="selectedStatuses"
        [showStatus]="[1, 0]"
        (selectionFilterApply)="applyStatusFilter()"
      >
      </app-status-filters>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Rechazo</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Status Filter -->

          
          <!-- Add button (only icon) -->
          <!-- Se comenta por motivos que sera estandar en todos lados y es interno en codigo para filtrar
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button> -->
        </div>
      </div>
    </div>
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2" >
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table
              class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSource"
              matSort
              [trackBy]="trackByFn"
            >
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Nombre
                </th>
                <td
                  mat-cell
                  *matCellDef="let rejectionType"
                  class="text-sm uppercase leading-tight"
                >
                <div *ngIf="getCode(rejectionType) as code">
                  <b class="f-12">{{ code }}</b>
                </div>
                  {{ rejectionType.name }}
                </td>
              </ng-container>

              <!-- Estado (mat-slide-toggle) -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let rejectionType">
                  <mat-slide-toggle
                    [checked]="rejectionType.statusId === 1"
                    (change)="onStatusChange($event.checked, rejectionType)"
                    color="primary"
                  >
                  </mat-slide-toggle>
                </td>
              </ng-container>
              
              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="px-6 py-3 text-left"
                ></th>
                <td
                  mat-cell
                  *matCellDef="let rejectionType"
                  class="px-6 py-3 text-left"
                >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionMenu"
                    matTooltip="Acciones"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(rejectionType)">
                      <mat-icon
                        svgIcon="heroicons_outline:pencil-square"
                      ></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(rejectionType)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="border-b"
              ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
      </div>

      <!-- Modales -->
      <ng-template #addModal>
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
          <mat-dialog-content class="modal-content">
            <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
              <!-- Código -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Código</mat-label>
                <input
                  matInput
                  name="externalKeys"
                  [(ngModel)]="currentCreateRejectionType.code"
                  required
                  />
              </mat-form-field>
              
              <!-- Nombre -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentCreateRejectionType.name"
                  name="name"
                  required
                  />
              </mat-form-field>
        
              <!-- Compañía -->
              <div class="col-span-2">
                <label>Compañía</label>
                <ng-select
                [items]="companyList"
                [(ngModel)]="currentCreateRejectionType.companyId"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Seleccione una compañía"
                name="company"
                [appendTo]="'body'"
                required
                >
              </ng-select>
          </div>
        
              <!-- Estado -->
              <!-- <div class="col-span-2 flex items-center">
                <span class="slide">Estado</span>
                <mat-slide-toggle
                name="validateStockInRouting"
                [(ngModel)]="currentCreateRejectionType.validateStockInRouting"
                color="primary"
                >
              </mat-slide-toggle>
          </div> -->
            </form>
          </mat-dialog-content>
          <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button
              mat-raised-button
              color="primary"
              (click)="createRejectionType()"
              [disabled]="!createForm.valid"
              >
              Guardar
            </button>
          </mat-dialog-actions>
        </ng-template>
        

      <!-- Modal Editar -->
      <ng-template #editModal>
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Editar Registro - {{ currentUpdateRejectionType.name }}
          </h2>
          <mat-dialog-content class="modal-content">
            <form #editForm="ngForm" class="grid grid-cols-2 gap-4">
              <!-- Código -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Código</mat-label>
                <input
                  matInput
                  name="externalKeys"
                  [(ngModel)]="currentUpdateRejectionType.code"
                  disabled
                  />
              </mat-form-field>
        
              <!-- Nombre -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  [(ngModel)]="currentUpdateRejectionType.name"
                  name="name"
                  required
                  />
              </mat-form-field>

              <!-- Compañía -->
              <div class="col-span-2">
                  <label>Compañía</label>
                  <ng-select
                  [items]="companyList"
                  [(ngModel)]="currentUpdateRejectionType.company"
                  (ngModelChange)="onCompanySelectionChange($event)"
                  [compareWith]="compareById"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Seleccione una compañía"
                  name="company"
                  [appendTo]="'body'"
                  required
                  >
              </ng-select>
          </div>
        
              <!-- Estadod -->
              <!-- <div class="col-span-2 flex items-center">
                <span class="slide">Estado</span>
                <mat-slide-toggle
                  [(ngModel)]="currentUpdateRejectionType.validateStockInRouting"
                  name="validateStockInRouting"
                  color="primary"
                >
                </mat-slide-toggle>
              </div> -->
            </form>
          </mat-dialog-content>
          <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button
              mat-raised-button
              color="primary"
              (click)="updateRejectionType(currentUpdateRejectionType._id)"
              [disabled]="!editForm.valid"
            >
              Guardar
            </button>
          </mat-dialog-actions>
        </ng-template>
        

      <!-- Modal Eliminar -->
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon
              svgIcon="heroicons_outline:exclamation-triangle"
              class="text-red-500 ml-4 mt-6"
              style="font-size: 32px"
            ></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
              Confirmar eliminación
            </h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">
            Conservar
          </button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Eliminar
          </button>
        </mat-dialog-actions>
      </ng-template>
    </div>
  </div>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="onFilterEvent()"
    (onCleanEvent)="onCleanEvent()"
  >
    <!-- Company Filter Section -->
    <app-configuration-filters
      [form]="companyFilterForm"
      [company]="true"
    ></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>
